import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { buildShopQueryParams } from "@/app/[domain]/(minimal-layout)/shop/_utilities/build-shop-query-params";
import { ProductCard } from "@/components/ProductCard/ProductCard.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
type QuarterlyProductProps = {
  readonly className?: string;
  readonly size?: "small" | "medium" | "large" | "default";
  readonly variant?: "primary" | "default" | "subtle";
  readonly position?: string;
  readonly promoPosition?: string;
};
export function QuarterlyProduct(t0) {
  const $ = _c(27);
  const {
    className,
    size,
    position,
    promoPosition
  } = t0;
  const {
    quarterlyProduct,
    yearlyProduct,
    redirectUrl,
    articleId
  } = usePaywall();
  const t1 = quarterlyProduct?.id || null;
  let t2;
  if ($[0] !== articleId || $[1] !== promoPosition || $[2] !== redirectUrl || $[3] !== t1) {
    t2 = buildShopQueryParams({
      articleId,
      productId: t1,
      promoPosition,
      redirectUrl
    });
    $[0] = articleId;
    $[1] = promoPosition;
    $[2] = redirectUrl;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const quarterlyProductQueryParams = t2;
  if (!quarterlyProduct) {
    return null;
  }
  const url = `/shop/checkout/billing-details${quarterlyProductQueryParams !== "" ? `?${quarterlyProductQueryParams}` : ""}`;
  let t3;
  if ($[5] !== className) {
    t3 = clsx(className, "relative flex hover:z-10 lg:py-2");
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      da: "K\xF8b nu",
      de: "Jetzt kaufen",
      en: "Buy now",
      no: "Kj\xF8p n\xE5",
      sv: "K\xF6p nu"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = yearlyProduct !== null ? 2 : 1;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      da: "Kvartalsvis betaling",
      de: "Viertelj\xE4hrliche Zahlung",
      en: "Quarterly payment",
      no: "Kvartalsvis betaling",
      sv: "Kvartals betalning"
    };
    t7 = {
      da: "kvartal",
      de: "Quartal",
      en: "quarter",
      no: "kvartal",
      sv: "kvartal"
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      da: "Personligt abonnement",
      de: "Pers\xF6nliches Abonnement",
      en: "Personal subscription",
      no: "Personlig abonnement",
      sv: "Personligt abonnemang"
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== quarterlyProduct.id) {
    t9 = {
      contentId: quarterlyProduct.id,
      contentSource: "paywall",
      contentType: "cta"
    };
    $[11] = quarterlyProduct.id;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = yearlyProduct === null ? "primary" : "default";
  let t11;
  if ($[13] !== position || $[14] !== quarterlyProduct || $[15] !== t10 || $[16] !== t5 || $[17] !== t9 || $[18] !== url) {
    t11 = {
      buttonTranslations: t4,
      footNoteStarCount: t5,
      periodHeadingTranslations: t6,
      periodTranslations: t7,
      position,
      product: quarterlyProduct,
      testId: "quarterly-product-id",
      titleTranslations: t8,
      trackingModel: t9,
      url,
      variant: t10
    };
    $[13] = position;
    $[14] = quarterlyProduct;
    $[15] = t10;
    $[16] = t5;
    $[17] = t9;
    $[18] = url;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="text-sm"><Translation da={"Fuld adgang for \xE9n person"} de={"Voller Zugang f\xFCr eine Person"} en="Full access for one person" no={"Full tilgang for \xE9n person"} sv={"Full tillg\xE5ng f\xF6r en person"} /></p>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== size || $[22] !== t11) {
    t13 = <ProductCard model={t11} size={size}>{t12}</ProductCard>;
    $[21] = size;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t3) {
    t14 = <div className={t3}>{t13}</div>;
    $[24] = t13;
    $[25] = t3;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}